import { EXTENDED_ACCESS_DURATION } from '../../../../common/utils/product-util';
import { addDays } from '../../../../common/utils/date-utils';

/**
 * Determines if a digital product is expired based on the ordered date, terms, and optional license end date.
 *
 * @param orderedDate
 * @param terms
 * @param licenseEndDate
 */
export function isExpired(orderedDate: string, terms: string, licenseEndDate?: string) {
  const currentDate = Date.now();
  return licenseEndDate
    ? new Date(licenseEndDate)?.getTime() < currentDate
    : expirationDate(orderedDate, terms)?.getTime() < currentDate;
}

/**
 * Calculates the expiration date for a digital product based on the ordered date and terms.
 *
 * @param orderedDate
 * @param terms
 */
export function expirationDate(orderedDate: string, terms: string) {
  return addDays(new Date(orderedDate), +(terms === '-1' || terms === 'always' ? EXTENDED_ACCESS_DURATION : terms));
}
